export const fundingAndMonitoring = state => state.studiesReducer.studentCourseSession.fundingAndMonitoring.fundingAndMonitoring

export const isLoading = state => state.studiesReducer.studentCourseSession.fundingAndMonitoring.isLoading

export const isSuccess = state => state.studiesReducer.studentCourseSession.fundingAndMonitoring.isSuccess

export const permissions = state => state.studiesReducer.studentCourseSession.fundingAndMonitoring.permissions

export const options = state => state.studiesReducer.studentCourseSession.fundingAndMonitoring.options
